<div class="pageHeader">
  <span
      class="text-dark fw-bolder   fs-4 flex place-items-center justify-center justify-items-center items-center">
      <!-- <img src="assets/img/school.svg" class="svg-icon svg-icon-3" style="width:30px"/>  -->
      <span class="my-auto">إدارة التواقيت</span>


  </span>
  <div class="action">
      <button (click)="showAddDayTimeModal()" class="inline-style-header">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#fff"
              class="w-4 h-4">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
          </svg>

          <span>إضافة توقيت</span>
      </button>
  </div>
</div>




<div class="card-body">
  <!-- begin::Table container -->
  <!-- <nz-spin [nzSpinning]="isWoringDayLoading" > -->

  <div class="table-responsive">
      <!-- begin::Table -->
      <!-- <div style="display: none;">
        {{WoringDayList[0]['day_ar']}}
      </div> -->
      <nz-spin [nzSpinning]="isWoringDayLoading" >
      <table   class="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4"
      class="w-full divide-y divide-gray-300 p-2 overflow-x-auto md:rounded-lg bg-white">
      <!-- begin::Table head -->
      <thead>
        <tr class="fw-bolder text-muted">

                         <th scope="col"
            class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">اليوم </th>
                         <th scope="col"
            class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">الوقت المتاح</th>
                         <th scope="col"
            class="py-3.5 pl-4 pr-3 text-left text-sm font-normal text-gray-600 sm:pl-6 capitalize text-right">الإجراء </th>
              </tr>
          </thead>
          <!-- end::Table head -->
          <!-- begin::Table body -->
          <tbody>
              <ng-container *ngFor="let item of WoringDayList">


                  <tr *ngIf="item['is_added']">

                          <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                          <div class="d-flex align-items-center">

                              <div class="d-flex justify-content-start flex-column">
                                  <a href="#" class="text-dark fw-bolder   fs-8">
                                      {{item['day_ar']}}

                                  </a>

                              </div>
                          </div>
                      </td>


                      <td class="d-flex justify-content-start flex-shrink-0" *ngIf="item['times'][0]"
                          style="border: unset;">



                          <ng-container *ngFor="let times of item['times'] ; let i = index">

                              <div *ngIf=" times['is_added'] == true" class="border border-primary border-dashed rounded py-2 px-4 m-2" >
                                  <span class="text-dark fw-bolder   d-block fs-8">
                                    {{  times['time']}}
                                  </span>
                              </div>


                          </ng-container>
                          <div class="border border-gray-300  border-dashed rounded py-2 px-4 m-2 cursor-pointer"
                              (click)="showAddTimeModal(item['id'])">
                              <span class="text-dark fw-bolder   d-block fs-8">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                      stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                                      <path stroke-linecap="round" stroke-linejoin="round"
                                          d="M12 4.5v15m7.5-7.5h-15" />
                                  </svg>

                              </span>
                          </div>





                      </td>


                      <td class="d-flex justify-content-start flex-shrink-0" *ngIf="item['times'][0] == null"
                          style="border: unset;">
                          <div class="border border-gray-300  border-dashed rounded py-2 px-4 m-2"
                              (click)="getTimeByDayIdRow(item['id'])">
                              <span class="text-dark fw-bolder   d-block fs-8">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                      stroke-width="1.5" stroke="currentColor" class="w-3 h-3">
                                      <path stroke-linecap="round" stroke-linejoin="round"
                                          d="M12 4.5v15m7.5-7.5h-15" />
                                  </svg>

                              </span>
                          </div>

                      </td>


                          <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-light text-gray-900 sm:pl-6 text-right">
                          <div class="d-flex align-items-cente cursor-pointer">

                              <div class="d-flex justify-content-start flex-column"
                              nz-popconfirm
                              nzPopconfirmTitle="Are you sure delete this Day?"
                              nzPopconfirmPlacement="bottom"
                              (nzOnConfirm)="deleteDays(item['id'])"

                              >
                              <svg class="svg-icon svg-icon-3" width="24" height="24" viewBox="0 0 24 24" fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                fill="#e61782" />
                              <path opacity="0.5"
                                d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                fill="#e61782" />
                              <path opacity="0.5" d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                fill="currentColor" />
                            </svg>


                              </div>
                          </div>

                      </td>
                  </tr>
              </ng-container>
          </tbody>
          <!-- end::Table body -->
      </table>
    </nz-spin>
      <!-- end::Table -->
  </div>
  <!-- end::Table container -->

<!-- </nz-spin> -->

</div>



<nz-modal [(nzVisible)]="isAddTimeVisible" [nzTitle]="modalTitle" [nzContent]="modalContent" [nzFooter]="modalFooter"
  (nzOnCancel)="handleAddTimeCancel()">
  <ng-template #modalTitle>{{"common.add_time" | translate}}</ng-template>

  <ng-template #modalContent style="float: right;">

      <p style="text-align: right;direction: rtl;">    {{"common.choose_time" | translate}}: </p>
      <nz-spin [nzSpinning]="isWoringDayIDLoading">
      <div class="row mb-2" data-kt-buttons="true">

          <ng-container *ngFor="let TimeListByDayIdRow of TimeListByDayIdRow ;" >
          <div class="col-md-3 mb-2" dir="rtl">

          <input  type="checkbox" class="btn-check" id="{{TimeListByDayIdRow['time']}}" [nzDisabled]="TimeListByDayIdRow['is_added']"
          value="{{TimeListByDayIdRow['time']}}" [(ngModel)]="TimeListByDayIdRow['is_added']" (change)="changeCheckboxTimeRow(TimeListByDayIdRow)"/><label class="
          btn btn-outline btn-outline-dashed btn-outline-default
          w-100
          p-1
        " for="{{TimeListByDayIdRow['time']}}"><span class="fw-bolder fs-8">{{TimeListByDayIdRow['time']}}</span></label>

  </div>
</ng-container>

</div>
</nz-spin>
  </ng-template>

  <ng-template #modalFooter>
      <button nz-button nzType="default" (click)="handleAddTimeCancel()">{{"common.close" | translate}} </button>
      <button nz-button nzType="primary" (click)="addNewTime()">

          {{"common.add" | translate}}
      </button>

  </ng-template>
</nz-modal>





  <nz-modal [(nzVisible)]="isAddDayTimeVisible" [nzTitle]="modalTitleDay"  (nzOnCancel)="handleAddDayTimeCancel()">
    <ng-template #modalTitleDay>   
        <p class="text-start"> {{"common.add_day_time" | translate}}</p>
      </ng-template>

      <div >
      <div>
          <p style="text-align: right;direction: rtl;"> {{"common.choose_day" | translate}} : </p>
          <div class="row mb-2" data-kt-buttons="true">
              <div class="col-md-12 mb-2" dir="rtl">
                  <nz-select nzShowSearch nzAllowClear [(ngModel)]="selectedDate" (ngModelChange)="changeSelectedDate($event)"  style="width: 100% !important;">
                      <ng-container *ngFor="let WoringDayList of listOfDay">
                          <nz-option nzLabel="{{WoringDayList['day_ar']}}" nzValue="{{WoringDayList['id']}}">
                          </nz-option>
                      </ng-container>
                  </nz-select>
              </div>
          </div>

          <p style="text-align: right;direction: rtl;"> {{"common.choose_time" | translate}} : </p>
          <nz-spin [nzSpinning]="isWoringDayIDLoading">
          <div class="row mb-2" data-kt-buttons="true">

              <ng-container *ngFor="let TimeListByDayId of TimeListByDayId ;" >
              <div class="col-md-3 mb-2" dir="rtl">

              <input  type="checkbox" class="btn-check" id="{{TimeListByDayId['time']}}"
              value="{{TimeListByDayId['time']}}" [(ngModel)]="TimeListByDayId['is_added']" (change)=" AddCheckboxTime(TimeListByDayId)"/><label class="
              btn btn-outline btn-outline-dashed btn-outline-default
              w-100
              p-1
            " for="{{TimeListByDayId['time']}}"><span class="fw-bolder fs-8">{{TimeListByDayId['time']}}</span></label>

      </div>
  </ng-container>

  </div>
</nz-spin>
      </div>
  </div>




<div *nzModalFooter>
  <div>
      <button nz-button nzType="default" (click)="handleAddDayTimeCancel()">إغلاق </button>
      <button nz-button nzType="primary" (click)="addDayAndTime()">

          {{"common.add" | translate}}
      </button>
  </div>
</div>
</nz-modal>
